import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { addInfraction, getUserInfractions, AddInfractionParams } from '@/services/infractionService';
import { toast } from 'sonner';

export const useInfractions = (userId?: string) => {
  const queryClient = useQueryClient();

  const { data: infractions, isLoading } = useQuery({
    queryKey: ['user-infractions', userId],
    queryFn: () => getUserInfractions(userId!),
    enabled: !!userId,
  });

  const addInfractionMutation = useMutation({
    mutationFn: (params: AddInfractionParams) => addInfraction(params),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['user-infractions'] });
      queryClient.invalidateQueries({ queryKey: ['admin-users'] });
      
      const strikeMsg = data.strike_count === 4 
        ? 'Usuario baneado permanentemente'
        : `Strike ${data.strike_count}/3 aplicado`;
      
      toast.success(`Infracción registrada. ${strikeMsg}`);
    },
    onError: (error: any) => {
      toast.error(error.message || 'Error al agregar infracción');
    },
  });

  return {
    infractions: infractions || [],
    isLoading,
    addInfraction: addInfractionMutation.mutate,
    isAdding: addInfractionMutation.isPending,
  };
};
